/** Shared `unknown` → primitive coercions for TotalConnect RTC WebSocket parsers. */

export function optString(v: unknown): string | undefined {
  return typeof v === "string" ? v : undefined;
}

export function optFiniteNumber(v: unknown): number | undefined {
  return typeof v === "number" && Number.isFinite(v) ? v : undefined;
}

export function optCallerId(v: unknown): number | undefined {
  const n = optFiniteNumber(v);
  if (n !== undefined) return n;
  if (typeof v === "string") {
    const parsed = parseInt(v, 10);
    return Number.isFinite(parsed) ? parsed : undefined;
  }
  return undefined;
}

export function optBool(v: unknown): boolean | undefined {
  return typeof v === "boolean" ? v : undefined;
}

/** String field that may be sent as a finite number (e.g. extension, slot). */
export function optStringOrFiniteNumberString(v: unknown): string | undefined {
  const s = optString(v);
  if (s !== undefined) return s;
  if (typeof v === "number" && Number.isFinite(v)) return String(v);
  return undefined;
}
